import {RepositoryFactory} from '@/repository/RepositoryFactory'
import ErrorMessages from "@/mixins/ErrorMessages";

const SageRepository = RepositoryFactory.get('sage')

export default {
  mixins: [ ErrorMessages ],
  methods: {
    async createSageSalesOrder(data, customer_id = null) {
      const total_value = data.formulation_items.reduce((a, b) => a + Number(b.quantity) * Number(b.price), 0)
      let payload = {
        product_order_id: data.id,
        customer_id: customer_id,
        document_no: data.product_order_code,
        customer_document_no: data.product_order_code,
        lines: data.formulation_items.map((n) => {
          return {
            line_type: "1",
            use_description: true,
            description: `${n.formulation_code} ${n.formulation_name}`,
            line_quantity: n.quantity + '',
            allocated_quantity: n.quantity + '',
            selling_unit_price: n.price + '',
            // tax_code_id: 1728
          }
        })
      }
      if (customer_id) {
        try {
          await SageRepository.createSalesOrder(payload)
        } catch (e) {
          this.showErrorMessage('Sage order create failed! please contact admin!')
        }
      } else {
        this.showErrorMessage('Sage order create failed! Customer not in the sage records', 5000)
      }
    },
    async createSageProductOrder(data) {
      const filtered_data = data.filter((x) => !!x.sage_supplier_id)
      const exec_data = data.filter((x) => !x.sage_supplier_id)
      let payload = filtered_data.map((n) => {
        return {
          order_id: n.order_id,
          order_type: 'raw_material',
          supplier_id: n.sage_supplier_id+'',
          document_no: n.order_code,
          supplier_document_no: n.order_code,
          lines: n.order_items.map((m) => {
            return {
              line_type: "1",
              use_description: true,
              description: m.company_product_name || m.company_product_code,
              line_quantity: m.quantity + '',
              allocated_quantity: m.quantity + '',
              unit_buying_price: m.gbp_price + '',
              // tax_code_id: 1728
            }
          })
        }
      })
      if(filtered_data.length > 0 ) {
        try {
          await SageRepository.createProductOrder({orders: payload})
        } catch (e) {
          this.showErrorMessage('Sage order create failed!. please contact admin!')
        }
      } else {
        this.showErrorMessage('Sage order create failed! Suppliers not in the sage records', 5000)
      }
    },

    async createSageSundryItemOrder(data) {
      let payload = {
        order_id: data.id,
        order_type: 'sundry_item',
        supplier_id: data.sundry_supplier_sage_id + '',
        document_no: data.sundry_order_code,
        supplier_document_no: data.sundry_order_code,
        lines: data.sundry_items.map((m) => {
          return {
            line_type: "1",
            use_description: true,
            description: m.sundry_product_name || m.sundry_item_code,
            line_quantity: m.quantity + '',
            allocated_quantity: m.quantity + '',
            unit_buying_price: m.price + '',
            // tax_code_id: 1728
          }
        })
      }
      if(data.sundry_supplier_sage_id) {
        try {
          await SageRepository.createProductOrder({orders: [payload]})
        } catch (e) {
          this.showErrorMessage('Sage order create failed!. please contact admin!')
        }
      }else{
        this.showErrorMessage('Sage order create failed! Customer not in the sage records', 5000)
      }
    },

    async createSageOtherServiceOrder(data){

      let payload = {
        order_id: data.id,
        order_type: 'other',
        supplier_id : data.other_supplier_sage_id,
        document_no: data.order_code,
        supplier_document_no: data.order_code,
        lines: data.order_items.map((n) => {
          return {
            line_type:1,
            use_description:true,
            description: n.description || n.other_supplier_service_name,
            line_quantity: n.quantity+ '',
            allocated_quantity: n.quantity+ '',
            unit_buying_price: n.unit_price + ''
          }
        })
      }
      if(data.other_supplier_sage_id) {
        try {
          await SageRepository.createProductOrder({orders: [payload]})
        } catch (e) {
          this.showErrorMessage('Sage order create failed!. please contact admin!')
        }
      }else{
        this.showErrorMessage('Sage order create failed! Customer not in the sage records', 5000)
      }
    },
    async createCustomerSageContact(customer_id, data){

      let payload = {
        user_id: data.id,
        first_name: data.first_name,
        last_name: data.last_name,
        emails: [{ email: data.email }],
        telephones: [{ country_code: data.country_code_main_telephone, subscriber_number: data.main_telephone }]
      }
      if(customer_id) {
        try {
          const data = await SageRepository.createCustomerContact(customer_id, payload)
        } catch (e) {
          this.showErrorMessage('Sage contact create failed!. please contact admin!')
        }
      }else{
        this.showErrorMessage('Sage contact create failed! Customer not in the sage records', 5000)
      }
    },
    async createSupplierSageContact(supplier_id, data){

      let payload = {
        user_id: data.id,
        first_name: data.first_name,
        last_name: data.last_name,
        emails: [{ email: data.email }],
        telephones: [{ country_code: data.country_code_telephone, subscriber_number: data.telephone }],
        mobiles: [ { country_code: data.country_code_mobile, subscriber_number: data.mobile } ] 
      }
      if(supplier_id) {
        try {
          const data = await SageRepository.createSupplierContact(supplier_id, payload)
        } catch (e) {
          this.showErrorMessage('Sage contact create failed!. please contact admin!')
        }
      }else{
        this.showErrorMessage('Sage contact create failed! Supplier not in the sage records', 5000)
      }
    }
  },
}
